import { render, staticRenderFns } from "./AllocationDialog.vue?vue&type=template&id=7f266820&scoped=true&lang=pug&"
import script from "./AllocationDialog.vue?vue&type=script&lang=ts&"
export * from "./AllocationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationDialog.vue?vue&type=style&index=0&id=7f266820&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f266820",
  null
  
)

export default component.exports